import * as React from 'react';

import { FormattedViewModel, TextType } from 'models';

import { FormattedParagraph } from 'components/common/formatted-paragraph';
import { SectionPlainText } from './section-text';

interface SectionListProps {
  formattedDescription: FormattedViewModel;
  index: number;
  textType: string;
  dataStid: string;
}

export const SectionPlainList = ({ formattedDescription, index, dataStid, textType }: SectionListProps) => (
  <div key={`${dataStid}-${index}`} className={`${dataStid}-${index} all-t-margin-two`}>
    {textType === TextType.PLAIN_TEXT && <SectionPlainText description={formattedDescription.description} />}
    {textType === TextType.HTML_TEXT && <FormattedParagraph text={formattedDescription.description} />}
  </div>
);

SectionPlainList.displayName = 'SectionPlainList';
